// extracted by mini-css-extract-plugin
module.exports = {"container":"mission-module--container--qkLj2","quote":"mission-module--quote--2jD-j"};